/* eslint-disable jsx-a11y/anchor-is-valid */
import * as _ from 'lodash'
import { useHistory, useLocation } from 'react-router'
import React, { useEffect, useState } from 'react'
import {
  Accordion as BootstrapAccordion,
  Card,
  Col,
  Dropdown,
  Row,
  Tab,
  Tabs,
} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  Box,
  Button,
  Drawer,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import FilterListIcon from '@mui/icons-material/FilterList'

import {
  KNOWLEDGE_ARCHIVED,
  KNOWLEDGE_KNOWLEDGE_CREATE_FROM_SCRATCH,
} from '@/config'
import UploadedDocuments from '@/routes/UploadedDocuments/UploadedDocuments'
import RichMarkdownContent from '@/components/UI/RichMarkdownContent'
import {
  deleteKnowledgeById,
  restoreKnowledgeById,
  getAllKnowledge,
} from '@/store/knowledge/actions'
import {
  isAllKnowledgeLoading,
  isAllKnowledgeSuccess,
  isTopicsLoading,
} from '@/store/knowledge/selector'
import { getAllUserGroupOptions } from '@/store/notifications/actions'
import KGroupsTree from '@/components/UI/KGroupsTree'
import PermissionWrapper from '../PermissionWrapper/PermissionWrapper'
import { TwoButtonModal as KnowledgeConfirmationModal } from '../Common'
import Pagination from '../Pagination/Pagination'
import AccordionCard from '@/components/UI/AccordionCard'
import { localDateTime } from '@/utils/formatUtils'
import '@/routes/Knowledge/AllKnowledge/AllKnowledge.scss'
import emptyKnowledge from '@/assets/New-images/empty-knowledge.svg'
import sortIcon from '@/assets/New-images/sort-blue-icon.svg'

function ArchiveKnowledgeDatatableView(props: any) {
  const { t } = useTranslation('translation')
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const [perPage, setPerPage] = useState(30)
  const [currentPage, setCurrentPage] = useState(1)
  const allKnowledgeSuccess = useSelector(isAllKnowledgeSuccess)
  const allKnowledgeLoading = useSelector(isAllKnowledgeLoading)
  const topicsLoading = useSelector(isTopicsLoading)

  const [activeTab, setActiveTab] = useState<string>(() => {
    const params = new URLSearchParams(location.search)
    return params.get('activeTab') || 'viewDocument'
  })
  const [activeKey, setActiveKey] = useState(null)
  const [selectedGroup, setSelectedGroup] = useState(null)
  const [showDeletePermanentlyModal, setShowDeletePermanentlyModal] =
    useState(false)
  const [deletedRowId, setDeletedRowId] = useState([])

  // Mobile responsive state
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [isTreeDrawerOpen, setIsTreeDrawerOpen] = useState(false)

  useEffect(() => {
    if (!topicsLoading) {
      dispatch(getAllUserGroupOptions())
    }
  }, [])

  useEffect(() => {
    // Keep the active tab in sync with the URL's `activeTab` query param.
    const query = new URLSearchParams(location.search)
    const tabFromQuery = query.get('activeTab')
    if (tabFromQuery && tabFromQuery !== activeTab) {
      setActiveTab(tabFromQuery)
    }
    // If there's no param, don't override current state; initial state already defaulted.
  }, [location.search])

  const [query, setQuery] = useState('')

  const onInputChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    setQuery(e.target.value)
  }

  const [selectedNodes, setSelectedNodes] = useState([])

  const deleteConfirmed = async (selectedRowIds: string[]) => {
    await dispatch(deleteKnowledgeById(selectedRowIds, false))
    dispatch(
      getAllKnowledge(
        3,
        currentPage,
        perPage,
        query,
        '',
        {},
        selectedNodes.length > 0,
        props.documentId,
        selectedGroup?._id,
        true,
        true,
      ),
    )
    setSelectedNodes([])
  }

  const restoreArchived = async (selectedRowIds: string[]) => {
    await dispatch(restoreKnowledgeById(selectedRowIds))
    dispatch(
      getAllKnowledge(
        3,
        currentPage,
        perPage,
        query,
        '',
        {},
        selectedNodes.length > 0,
        props.documentId,
        selectedGroup?._id,
        true,
        true,
      ),
    )
    setSelectedNodes([])
  }

  const onSortHandler = (selector: any, direction: string) => {
    dispatch(
      getAllKnowledge(
        3,
        currentPage,
        perPage,
        query,
        '',
        {
          sort_field: selector === 'name' ? 'question' : selector,
          sort_order: direction === 'desc' ? 'dsc' : 'asc',
        },
        selectedNodes.length > 0,
        props.documentId,
        selectedGroup?._id,
        true,
        true,
      ),
    )
  }

  useEffect(() => {
    if (activeTab === 'viewKnowledge') {
      dispatch(
        getAllKnowledge(
          3,
          currentPage,
          perPage,
          query,
          '',
          {},
          selectedNodes.length > 0,
          props.documentId,
          !props.documentId ? selectedGroup?._id : null,
          true,
          true,
        ),
      )
    }
  }, [selectedGroup, activeTab])

  const addToSelectedRows = (event: any, id: string) => {
    let data: any[] = [...selectedNodes]
    if (event.target.checked) {
      const isPresent = data.indexOf(id)
      if (isPresent < 0) {
        data.push(id)
      }
    } else {
      const oldData = [...selectedNodes]
      const index = oldData.indexOf(id)
      oldData.splice(index, 1)
      data = [...oldData]
    }
    setSelectedNodes([..._.uniq(data)])
  }

  const onSelectAllRows = (event: any) => {
    if (event.target.checked) {
      if (
        allKnowledgeSuccess &&
        allKnowledgeSuccess.intents &&
        allKnowledgeSuccess.intents.length > 0
      ) {
        let data: any[] = [
          ...allKnowledgeSuccess.intents.map((intent: any) => intent._id),
        ]
        setSelectedNodes([..._.uniq(data)])
      }
    } else {
      setSelectedNodes([])
    }
  }

  /**
   * Used to paginate data based on per page and page number
   * @param newPerPage
   * @param page
   */
  const handlePerRowsChange = async (newPerPage: number, page: number) => {
    setPerPage(newPerPage)
    setCurrentPage(page)
    dispatch(
      getAllKnowledge(
        3,
        page,
        newPerPage,
        query,
        '',
        {},
        selectedNodes.length > 0,
        props.documentId,
        selectedGroup?._id,
        true,
        true,
      ),
    )
  }

  /**
   *
   * @param page Pagination on change of page
   */
  const handlePageChange = (page: number) => {
    setCurrentPage(page)
    dispatch(
      getAllKnowledge(
        3,
        page,
        perPage,
        query,
        '',
        {},
        selectedNodes.length > 0,
        props.documentId,
        selectedGroup?._id,
        true,
        true,
      ),
    )
  }

  const knowledgeHtml = (
    <>
      <div className="all-knowledge-search d-flex flex-wrap align-items-center mb-2">
        <Dropdown className="mr-2 sort-dropdown">
          <Dropdown.Toggle
            className="btn btn-outline-primary font-600 py-1 my-1 "
            variant="default"
            id="dropdown-basic"
          >
            <img src={sortIcon} alt="" className="mr-2" />
            {t('Sort')}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => {
                onSortHandler('updated_at', 'desc')
              }}
            >
              {t('Most Recent')}
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                onSortHandler('name', 'asc')
              }}
            >
              {t('Ascending')}
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                onSortHandler('name', 'desc')
              }}
            >
              {t('Descending')}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <div className="web-links my-0 mr-0">
          <input
            type="text"
            className="form-control h-auto"
            placeholder={t('Search Knowledge Base')}
            onChange={onInputChangeHandler}
          />
        </div>
      </div>
      <div className="d-flex flex-wrap justify-content-between align-items-center mt-1">
        <div className="d-flex align-items-center">
          <div className="custom-checkbox mr-3 align-items-center">
            <input
              type="checkbox"
              className="mr-2"
              id="select-all"
              checked={
                allKnowledgeSuccess &&
                allKnowledgeSuccess.intents &&
                allKnowledgeSuccess.intents.length > 0 &&
                selectedNodes.length === allKnowledgeSuccess.intents.length
              }
              onChange={onSelectAllRows}
            />
            <label htmlFor="select-all" className="mb-0">
              {t('Select all')}
            </label>
          </div>
          {selectedNodes && selectedNodes.length > 0 && (
            <PermissionWrapper>
              <button
                className="btn btn-suggest py-0 font-sm"
                onClick={() => restoreArchived(selectedNodes)}
              >
                {t('Restore Selected')}
              </button>

              <button
                className="btn btn-outline-danger border-0 py-0 font-600 font-sm"
                onClick={() => {
                  setShowDeletePermanentlyModal(true)
                  setDeletedRowId(selectedNodes)
                }}
              >
                {t('Delete Selected')}
              </button>
            </PermissionWrapper>
          )}
        </div>
      </div>
      <BootstrapAccordion
        defaultActiveKey={
          allKnowledgeSuccess && allKnowledgeSuccess.intents.length > 0
            ? allKnowledgeSuccess.intents[0]._id
            : null
        }
        className="accordion-viewby mt-3"
      >
        {allKnowledgeSuccess?.intents?.map((knowledge: any) => {
          return (
            <Card
              className={activeKey === '0' ? 'active' : 'notactive'}
              key={knowledge?._id}
            >
              <AccordionCard
                id={knowledge?._id}
                title={
                  knowledge.questions && knowledge.questions.length > 0
                    ? knowledge.questions[knowledge.questions.length - 1].text
                    : ''
                }
                breadcrumbs={
                  knowledge.breadcrumbs && knowledge.breadcrumbs.length > 0
                    ? knowledge.breadcrumbs
                    : []
                }
                expanded={activeKey === knowledge?._id}
                selected={selectedNodes.indexOf(knowledge?._id) >= 0}
                onToggle={() =>
                  setActiveKey(
                    activeKey === knowledge?._id ? null : knowledge?._id,
                  )
                }
                onSelect={checked => {
                  const event = {
                    target: { checked },
                    preventDefault: () => {},
                    stopPropagation: () => {},
                  }
                  addToSelectedRows(event, knowledge?._id)
                }}
                actions={[
                  {
                    label: t('Restore'),
                    variant: 'outlined',
                    color: 'primary',
                    onClick: () => restoreArchived([knowledge._id]),
                  },
                  {
                    label: t('Delete'),
                    variant: 'outlined',
                    color: 'error',
                    onClick: () => {
                      setDeletedRowId([knowledge._id])
                      setShowDeletePermanentlyModal(true)
                    },
                  },
                ]}
                content={
                  <>
                    <div>
                      <h3 className="clr-black mb-1">{t('Answer')}</h3>
                      <Typography>
                        {knowledge.responses &&
                        knowledge.responses.length > 0 ? (
                          <RichMarkdownContent
                            contextText={knowledge.responses[0].text}
                          />
                        ) : (
                          ''
                        )}
                      </Typography>
                    </div>
                    <Row className="mt-3">
                      <Col md={3} className="my-2 my-md-0">
                        <h3 className="clr-black mb-1">{t('Created By')}</h3>
                        <Typography>{knowledge?.author_email}</Typography>
                      </Col>
                      <Col md={3} className="my-2 my-md-0">
                        <h3 className="clr-black mb-1">{t('Last Updated')}</h3>
                        <Typography>
                          {localDateTime(knowledge.updated_at)}
                        </Typography>
                      </Col>
                      <Col md={3} className="my-2 my-md-0"></Col>
                      {knowledge?.document_name && (
                        <Col md={3} className="my-2 my-md-0">
                          <h3 className="clr-black mb-1">
                            {t('Generated From')}
                          </h3>
                          <Typography>{knowledge?.document_name}</Typography>
                        </Col>
                      )}
                    </Row>
                  </>
                }
              />
            </Card>
          )
        })}
      </BootstrapAccordion>

      {/* empty state */}
      {allKnowledgeSuccess &&
        allKnowledgeSuccess.intents.length === 0 &&
        !props.manageDocument && (
          <div className="empty-knowledge text-center my-5">
            <h3 className="h6 clr-grey-txt7 mb-3">
              {t('You have yet to create knowledge')}
            </h3>
            <figure className="h-auto">
              <img src={emptyKnowledge} alt="" />
            </figure>
            <div className="clr-primary font-weight-bold">
              {/* Drop a document here <span className="clr-grey-txt7">or</span>{" "} <br /> */}
              <Link to={KNOWLEDGE_KNOWLEDGE_CREATE_FROM_SCRATCH}>
                {t('Click here to get started')}
              </Link>
            </div>
          </div>
        )}
      {allKnowledgeSuccess &&
        allKnowledgeSuccess.pagination &&
        allKnowledgeSuccess.intents.length > 0 && (
          <Pagination
            currentPage={currentPage}
            pagination={allKnowledgeSuccess.pagination}
            paginationPerPage={perPage}
            pageChange={handlePerRowsChange}
            onChangePage={handlePageChange}
            style={{ position: 'relative' }}
          />
        )}
    </>
  )

  return (
    <>
      <KnowledgeConfirmationModal
        show={showDeletePermanentlyModal}
        title={t('Confirm Delete')}
        message={t(
          'Are you sure you would like to delete? Deleted items would be deleted permanently',
        )}
        size={'lg'}
        leftButtonText={t('Delete')}
        leftButtonClassName="btn btn-outline-danger font-weight-normal mx-2"
        rightButtonText={t('Cancel')}
        rightButtonClassName="btn btn-outline-primary font-weight-normal mx-2"
        onClickLeftButton={() => {
          setShowDeletePermanentlyModal(false)
          deleteConfirmed(deletedRowId)
        }}
        onClickRightButton={() => {
          setShowDeletePermanentlyModal(false)
        }}
        onClickClose={() => setShowDeletePermanentlyModal(false)}
      />

      {props.manageDocument && (
        <>
          <Row className="mb-4 position-relative manage-document-knowledge">
            <Col lg={12} md={12} className="knowledge-modules mb-4 mb-md-0">
              <div className="knowledge-box p-0 build-knowbox text-left d-flex flex-column">
                {!allKnowledgeLoading && knowledgeHtml}
              </div>
            </Col>
          </Row>
        </>
      )}

      {!props.manageDocument && (
        <>
          <div>
            <div className="tw-flex tw-flex-col md:tw-flex-row">
              {/* Mobile Drawer */}
              {isMobile && (
                <Drawer
                  variant="temporary"
                  open={isTreeDrawerOpen}
                  onClose={() => setIsTreeDrawerOpen(false)}
                  ModalProps={{
                    keepMounted: true, // Better open performance on mobile
                  }}
                  sx={{
                    display: { xs: 'block', md: 'none' },
                    '& .MuiDrawer-paper': {
                      boxSizing: 'border-box',
                      width: { xs: '75vw', sm: '280px' },
                      maxWidth: '320px',
                      boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                      border: 'none',
                    },
                  }}
                >
                  <KGroupsTree
                    syncsState={true}
                    actions={{ add: true, edit: true, delete: true }}
                    archivedRoute={KNOWLEDGE_ARCHIVED}
                    showsManageGroups={true}
                    onSelectGroup={group => {
                      setSelectedGroup(group)
                      setIsTreeDrawerOpen(false)
                    }}
                  />
                </Drawer>
              )}

              {/* Desktop Inline */}
              {!isMobile && (
                <KGroupsTree
                  syncsState={true}
                  actions={{ add: true, edit: true, delete: true }}
                  archivedRoute={KNOWLEDGE_ARCHIVED}
                  showsManageGroups={true}
                  slotProps={{ root: { className: 'tw-w-full md:tw-w-2/12' } }}
                  onSelectGroup={group => {
                    setSelectedGroup(group)
                  }}
                />
              )}

              <div className="tw-w-full md:tw-w-10/12">
                {/* Mobile Groups Toggle Button */}
                <Button
                  variant="outlined"
                  startIcon={<FilterListIcon />}
                  onClick={() => setIsTreeDrawerOpen(true)}
                  sx={{
                    display: { xs: 'inline-flex', md: 'none' },
                    mb: 2,
                    ml: 2,
                  }}
                >
                  {t('Groups')}
                </Button>

                <Box
                  className="tw-px-4 tw-py-2"
                  sx={{ '& nav': { display: 'inline-flex' } }}
                >
                  <Tabs
                    activeKey={activeTab}
                    onSelect={(e: string | null) => {
                      if (!e) return
                      setActiveTab(e)
                      const params = new URLSearchParams(
                        history.location.search,
                      )
                      params.set('activeTab', e)
                      history.replace({
                        pathname: history.location.pathname,
                        search: params.toString(),
                      })
                    }}
                  >
                    <Tab eventKey="viewDocument" title="Documents">
                      {activeTab === 'viewDocument' && (
                        <UploadedDocuments
                          isArchived={true}
                          queryString={`?group=${selectedGroup?._id}`}
                          selectedGroupId={selectedGroup?._id}
                        />
                      )}
                    </Tab>
                    <Tab eventKey="viewKnowledge" title={t('Flash Cards')}>
                      {activeTab === 'viewKnowledge' && knowledgeHtml}
                    </Tab>
                  </Tabs>
                </Box>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default ArchiveKnowledgeDatatableView
